import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, unref as _unref } from "vue";
const _hoisted_1 = { class: "cd-edit__header" };
const _hoisted_2 = { class: "cd-edit__title" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["value"];
const _hoisted_5 = { class: "cd-edit__drag" };
const _hoisted_6 = { class: "cd-edit__tag" };
const _hoisted_7 = { class: "cd-edit__footer" };
const _hoisted_8 = ["disabled"];
import { reactive, computed } from 'vue';
import { useToast } from 'vue-toastification';
import i18n from '@/i18n';
import router from '@/router';
import Alert from '@/components/_atoms/Alert';
import CustomerDistributionInfoEdit from '@/features/CustomerDistribution/components/edit/CustomerDistributionInfoEdit.vue';
import CustomerDistributionDrag from '@/features/CustomerDistribution/components/edit/CustomerDistributionDrag.vue';
import CustomerDistributionModal from '@/features/CustomerDistribution/components/edit/CustomerDistributionModal.vue';
import CustomerDistributionLoadingEdit from '@/features/CustomerDistribution/components/edit/CustomerDistributionLoadingEdit.vue';
import { fetchRule, putRule } from '@/features/CustomerDistribution/data';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerDistributionEdit',
    props: {
        id: {}
    },
    setup(__props) {
        const props = __props;
        const state = reactive({
            getClass: null,
            loading: false,
            toast: {
                store_type: false,
                enableOverload: false,
            },
            item: {
                name: '',
                createdAt: '',
                slot: 0,
                id: 0,
                mainRule: true,
                enableOverload: false,
                content: {
                    match_city_state: {
                        value: '',
                    },
                    orderby: {
                        seller: [],
                        store: [],
                    },
                    priority: {
                        value: 'store',
                    },
                    conditions: [
                        {
                            store_type: false,
                        },
                    ],
                },
            },
            id: '',
            openModal: false,
        });
        const toast = useToast();
        let defaultItem;
        const disabledButton = computed(() => {
            return JSON.stringify(state.item) === JSON.stringify(defaultItem);
        });
        const verifyIfExistsData = computed(() => {
            const { content } = state.item;
            return content.orderby.store.length && content.orderby.seller.length && content.match_city_state.value;
        });
        const updateItemDrag = item => {
            state.item.content.orderby.store = item.store;
            state.item.content.orderby.seller = item.seller;
        };
        const fetchInfoEdit = async () => {
            state.loading = true;
            await fetchRule(props.id)
                .then(response => {
                state.item = response;
                defaultItem = JSON.parse(JSON.stringify(response));
            })
                .finally(() => {
                state.loading = false;
            });
        };
        const formatContentRuleParam = (content) => {
            const matchCityState = content.match_city_state.value;
            return {
                conditions: content.conditions,
                match_city_state: {
                    value: matchCityState,
                },
                priority: {
                    value: 'store',
                },
                orderby: {
                    store: content.orderby.store
                        .filter(item => {
                        if (item.column === 'MATCH_CITY_STATE' && matchCityState === 'False') {
                            return item.column !== 'MATCH_CITY_STATE';
                        }
                        return item;
                    })
                        .map((item, index) => ({
                        column: item.column,
                        clause: 'DESC',
                        priority: index + 1,
                    })),
                    seller: content.orderby.seller.map((item, index) => ({
                        column: item.column,
                        clause: 'DESC',
                        priority: index + 1,
                    })),
                },
            };
        };
        const saveRule = () => {
            state.openModal = false;
            const { id, name, slot, enableOverload, content } = state.item;
            const contentRule = formatContentRuleParam(content);
            putRule(id, name, slot, enableOverload, contentRule).then(response => {
                if (response?.success) {
                    toast.success(i18n.global.t('customer-distribution.edit.success'), {
                        timeout: 5000,
                    });
                    toCustomerDistribution();
                }
            });
        };
        const toCustomerDistribution = () => {
            router.push('/base-management/customer-distribution');
        };
        fetchInfoEdit();
        return (_ctx, _cache) => {
            const _component_el_switch = _resolveComponent("el-switch");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_base_card_v2, { class: "cd-edit" }, {
                    default: _withCtx(() => [
                        _createElementVNode("section", _hoisted_1, [
                            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('customer-distribution.edit.title')), 1),
                            _createElementVNode("p", {
                                class: "cd-edit__description",
                                innerHTML: _ctx.$t('customer-distribution.edit.description')
                            }, null, 8, _hoisted_3)
                        ]),
                        _createVNode(CustomerDistributionInfoEdit, {
                            title: _ctx.$t('customer-distribution.edit.rule.title'),
                            description: _ctx.$t('customer-distribution.edit.rule.description')
                        }, {
                            default: _withCtx(() => [
                                (!state.loading)
                                    ? (_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        value: state.item.name,
                                        disabled: ""
                                    }, null, 8, _hoisted_4))
                                    : (_openBlock(), _createBlock(CustomerDistributionLoadingEdit, {
                                        key: 1,
                                        type: "input"
                                    }))
                            ]),
                            _: 1
                        }, 8, ["title", "description"]),
                        _createVNode(CustomerDistributionInfoEdit, {
                            tooltip: _ctx.$t('customer-distribution.edit.priority.tooltip'),
                            title: _ctx.$t('customer-distribution.edit.priority.title'),
                            description: _ctx.$t('customer-distribution.edit.priority.description')
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                    (!state.loading)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (verifyIfExistsData.value)
                                                ? (_openBlock(), _createBlock(CustomerDistributionDrag, {
                                                    key: 0,
                                                    store: state.item.content.orderby.store,
                                                    seller: state.item.content.orderby.seller,
                                                    match_city_state: state.item.content.match_city_state.value,
                                                    loading: state.loading,
                                                    "onUpdate:loading": _cache[0] || (_cache[0] = ($event) => ((state.loading) = $event)),
                                                    onUpdate: updateItemDrag,
                                                    onMatchCityState: _cache[1] || (_cache[1] = val => (state.item.content.match_city_state.value = val))
                                                }, null, 8, ["store", "seller", "match_city_state", "loading"]))
                                                : _createCommentVNode("", true)
                                        ], 64))
                                        : (_openBlock(), _createBlock(CustomerDistributionLoadingEdit, {
                                            key: 1,
                                            type: "drag"
                                        }))
                                ])
                            ]),
                            _: 1
                        }, 8, ["tooltip", "title", "description"]),
                        _createVNode(CustomerDistributionInfoEdit, {
                            title: _ctx.$t('customer-distribution.edit.ecommerce.title'),
                            description: _ctx.$t('customer-distribution.edit.ecommerce.description')
                        }, {
                            default: _withCtx(() => [
                                (!state.loading)
                                    ? (_openBlock(), _createBlock(_component_el_switch, {
                                        key: 0,
                                        modelValue: state.item.content.conditions[0].store_type,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((state.item.content.conditions[0].store_type) = $event))
                                    }, null, 8, ["modelValue"]))
                                    : (_openBlock(), _createBlock(CustomerDistributionLoadingEdit, {
                                        key: 1,
                                        type: "toggle"
                                    }))
                            ]),
                            _: 1
                        }, 8, ["title", "description"]),
                        _createVNode(CustomerDistributionInfoEdit, {
                            title: _ctx.$t('customer-distribution.edit.replace-rule.title'),
                            description: _ctx.$t('customer-distribution.edit.replace-rule.description')
                        }, {
                            default: _withCtx(() => [
                                (!state.loading)
                                    ? (_openBlock(), _createBlock(_component_el_switch, {
                                        key: 0,
                                        modelValue: state.item.enableOverload,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((state.item.enableOverload) = $event))
                                    }, null, 8, ["modelValue"]))
                                    : (_openBlock(), _createBlock(CustomerDistributionLoadingEdit, {
                                        key: 1,
                                        type: "toggle"
                                    }))
                            ]),
                            _: 1
                        }, 8, ["title", "description"]),
                        _createVNode(CustomerDistributionInfoEdit, {
                            title: _ctx.$t('customer-distribution.edit.leveling.title'),
                            description: _ctx.$t('customer-distribution.edit.leveling.description')
                        }, {
                            description: _withCtx(() => [
                                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('customer-distribution.edit.leveling.info')), 1)
                            ]),
                            default: _withCtx(() => [
                                (!state.loading)
                                    ? (_openBlock(), _createBlock(_unref(Alert), {
                                        key: 0,
                                        type: "info",
                                        message: _ctx.$t('customer-distribution.edit.leveling.alert')
                                    }, null, 8, ["message"]))
                                    : (_openBlock(), _createBlock(CustomerDistributionLoadingEdit, {
                                        key: 1,
                                        type: "alert"
                                    }))
                            ]),
                            _: 1
                        }, 8, ["title", "description"]),
                        _createElementVNode("section", _hoisted_7, [
                            (!state.loading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("button", {
                                        class: "btn btn-outline-ctx-primary",
                                        onClick: toCustomerDistribution
                                    }, _toDisplayString(_ctx.$t('customer-distribution.edit.footer.btn-back')), 1),
                                    _createElementVNode("button", {
                                        class: "btn btn-primary",
                                        disabled: disabledButton.value,
                                        onClick: _cache[4] || (_cache[4] = () => (state.openModal = true))
                                    }, _toDisplayString(_ctx.$t('customer-distribution.edit.footer.btn-save')), 9, _hoisted_8)
                                ], 64))
                                : (_openBlock(), _createBlock(CustomerDistributionLoadingEdit, {
                                    key: 1,
                                    type: "buttons"
                                }))
                        ])
                    ]),
                    _: 1
                }),
                _createVNode(CustomerDistributionModal, {
                    "is-visible": state.openModal,
                    onSave: saveRule,
                    onHide: _cache[5] || (_cache[5] = ($event) => (state.openModal = false))
                }, null, 8, ["is-visible"])
            ], 64));
        };
    }
});
